var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("WrapperDocRef", {
        attrs: { title: _vm.$t("message.refdocs") },
        scopedSlots: _vm._u(
          [
            _vm.purchase.status == "approved"
              ? {
                  key: "content",
                  fn: function() {
                    return [
                      _c("BaseSectionDocRefLink", {
                        attrs: {
                          title:
                            _vm.$t("sidebar.purchaseorder") +
                            " (" +
                            _vm.purchase.reference.purchase_orders.length +
                            ")",
                          links: _vm.POLinks,
                          createButtonText: _vm.$t("newdocuments.po"),
                          showCreateButton:
                            _vm.getPRStatus(
                              _vm.purchase,
                              _vm.purchase.reference.purchase_orders.length
                                ? _vm.purchase.reference.purchase_orders[0]
                                : null,
                              _vm.$t,
                              _vm.mixin
                            ).status != "completed"
                        },
                        on: { onCreate: _vm.handleClickCreatePO }
                      })
                    ]
                  },
                  proxy: true
                }
              : {
                  key: "content",
                  fn: function() {
                    return [_vm._v("\n      -\n    ")]
                  },
                  proxy: true
                }
          ],
          null,
          true
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: {
            id: "createPOModal",
            tabindex: "-1",
            role: "dialog",
            "aria-hidden": "true",
            "data-keyboard": "false",
            "data-backdrop": "static"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-lg-90-percent",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "col row no-padding no-margin" }, [
                    _c("div", { staticClass: "col-6 no-padding" }, [
                      _c("h5", { staticClass: "modal-title" }, [
                        _vm._v(_vm._s(_vm.$t("sidebar.purchaseorder")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-6 no-padding text-right" },
                      [
                        [
                          !_vm.nextPoCode
                            ? _c("h5", { staticClass: "modal-title" }, [
                                _c("i", {
                                  staticClass: "fas fa-spinner spin",
                                  staticStyle: {
                                    "font-size": "15px",
                                    position: "relative",
                                    top: "-1px"
                                  }
                                })
                              ])
                            : _c("h5", { staticClass: "modal-title" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.nextPoCode) +
                                    "\n                "
                                )
                              ])
                        ]
                      ],
                      2
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    [
                      _vm.showFormPO
                        ? _c("FormPurchase", {
                            attrs: {
                              purchase: _vm.purchase,
                              validation: _vm.validateForm
                            },
                            on: { submit: _vm.onSubmitPurchase }
                          })
                        : _c("span", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("message.loading")) +
                                "\n            "
                            )
                          ])
                    ]
                  ],
                  2
                ),
                _vm._v(" "),
                !_vm.$store.state.app.loading
                  ? _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.closePOModal()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-web",
                          attrs: { disabled: !_vm.showFormPO, type: "button" },
                          on: {
                            click: function($event) {
                              _vm.validateForm++
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.save")))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.app.loading
                  ? _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light",
                          attrs: { type: "button", disabled: "" }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                      ),
                      _vm._v(" "),
                      _vm._m(0)
                    ])
                  : _vm._e()
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-web", attrs: { type: "button", disabled: "" } },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c571e10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c571e10","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/purchases/pr/include/RefPO.vue
// module id = null
// module chunks = 